module.exports = __webpack_public_path__ + "img/p3-bg.c0f0db75.webp";